function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SearchTemplate = require('./search.template');
var _require = require('../search-nav'),
  classifySearchQuery = _require.classifySearchQuery;
var Search = /*#__PURE__*/function () {
  function Search(app, mod) {
    _classCallCheck(this, Search);
    this.app = app;
    this.mod = mod;
    this.data = {
      placeholder: 'Search by Block Hash, Transaction Signature, Public Key, or UTXOKEY'
    };
  }
  return _createClass(Search, [{
    key: "render",
    value: function render(container) {
      if (!container) {
        return;
      }
      this.container = container;
      this.app.browser.replaceElementContentBySelector(SearchTemplate(this.data), container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var form = root.querySelector('.explorer-search-form');
      var input = root.querySelector('.explorer-search-input');
      if (!form || !input) {
        return;
      }
      form.onsubmit = function (event) {
        event.preventDefault();
        _this.submitSearch(input.value);
      };
    }
  }, {
    key: "submitSearch",
    value: function submitSearch() {
      var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var match = classifySearchQuery(this.app, raw);
      if (!match) {
        var _this$app$browser, _this$app$browser$ale;
        (_this$app$browser = this.app.browser) === null || _this$app$browser === void 0 || (_this$app$browser$ale = _this$app$browser.alert) === null || _this$app$browser$ale === void 0 || _this$app$browser$ale.call(_this$app$browser, 'Enter a valid block hash (32 bytes), transaction signature (64 bytes), public key (33 bytes), or UTXOKEY (59 bytes).');
        return;
      }
      if (match.type === 'block') {
        this.mod.renderBlock(match.value, {
          pushState: true,
          animate: true
        });
        return;
      }
      if (match.type === 'address') {
        this.mod.renderAddress(match.value, {
          pushState: true,
          animate: true
        });
        return;
      }
      if (match.type === 'utxo') {
        this.mod.renderUtxo(match.value, {
          pushState: true,
          animate: true
        });
        return;
      }
      if (match.type === 'transaction') {
        this.mod.renderTransactionSignature(match.value, {
          pushState: true,
          animate: true
        });
      }
    }
  }]);
}();
module.exports = Search;